import { Component, Input, OnInit } from "@angular/core";
import { Navigator } from "src/app/components/menu/navigator";
import { EventsService } from "src/app/services/event/event.service";
import { Browser } from "@capacitor/browser";
import { Platform } from "@ionic/angular";

declare var window: any;

@Component({
  selector: "app-deposit-success-failure",
  templateUrl: "./deposit-success-failure.component.html",
  styleUrls: ["./deposit-success-failure.component.scss"],
})
export class DepositSuccessFailureComponent implements OnInit {
  @Input() amount: string;
  @Input() message: string;
  @Input() status: boolean;
  @Input() flag: string;
  @Input() flagPending: boolean = false;
  

  public paymentMessage: string;
  public closeWindowFlag: boolean = false;

  constructor(
    public events: EventsService,
    public navigator: Navigator,
    private platform: Platform
  ) {}

  ngOnInit() {
    if (this.flag == "paypal" || this.flag == "interac") this.paypalAction(this.flag);
    this.paymentMessage = this.message;
  }

  ionViewDidLeave() {
    this.events.publish("event:lobby:show");
    this.events.publish("event:notification:resume");
  }

  public closePopover() {
    this.events.publish("event:lobby:show");
    window._window_has_closed = true;
    return this.navigator.dismissAll();
  }

  public closeWindow = () => {
    this.events.publish("event:lobby:show");
    this.events.publish("event:notification:resume");
    window._window_has_closed = true;
    // Browser.close();
    window.close();
  };

  isMobileApp() {
    return this.platform.is("capacitor");
  }

  public paypalAction(paypalFlag) {
    if (paypalFlag == "paypal" || this.flag == "interac") return (this.closeWindowFlag = true);
    return (this.closeWindowFlag = false);
  }
}
